export default "__VITE_ASSET__9VanWj3x__"